import type { PluginManifest } from "@d12labs/plugins/types";

export const manifest: PluginManifest = {
	name: "ledger",
	label: "Ledger",
	description:
		"Session cost ledger. Laptops upload raw transcripts; this plugin prices them and serves the dashboard.",
	version: "0.1.0",
	navItems: [{ label: "Ledger", href: "/ledger", icon: "Receipt" }],
	settings: {
		id: "ledger",
		title: "Ledger",
		icon: "Receipt",
		blurb: "The only secret on the machines that upload raw session files.",
		rows: [
			{
				key: "LEDGER_INGEST_TOKEN",
				label: "Ingest token",
				secret: true,
				help: "Bearer token Odyssey and Zeus send to receive a short-lived upload URL. Blank disables uploads. The dashboard does not use this token.",
			},
			{
				key: "LEDGER_S3_BUCKET", // gitleaks:allow env name, not a secret
				label: "Ledger bucket",
				help: "Private bucket for raw transcripts. Blank uses the app attachments bucket. Set this so laptop uploads do not land next to avatars.",
			},
			{
				key: "LEDGER_S3_ENDPOINT", // gitleaks:allow env name, not a secret
				label: "Ledger bucket endpoint",
				help: "URL used to sign ledger upload URLs. Blank uses S3_ENDPOINT. For an AWS bucket in us-east-1, use https://s3.us-east-1.amazonaws.com.",
			},
		],
	},
};
